import React, { Fragment, useState, useEffect } from "react";
import FsLightbox from "fslightbox-react";
import Chart from "react-apexcharts";

import {
  Row,
  Col,
  Nav,
  Tab,
} from "react-bootstrap";
import Card from "../Card";
import { FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
// img

import avatars11 from "../../assets/images/avatars/01.png";
import avatars22 from "../../assets/images/avatars/avtar_1.png";
import avatars33 from "../../assets/images/avatars/avtar_2.png";
import avatars44 from "../../assets/images/avatars/avtar_3.png";
import avatars55 from "../../assets/images/avatars/avtar_4.png";
import avatars66 from "../../assets/images/avatars/avtar_5.png";
import avatars2 from "../../assets/images/avatars/02.png";
import avatars3 from "../../assets/images/avatars/03.png";
import avatars4 from "../../assets/images/avatars/04.png";
import avatars5 from "../../assets/images/avatars/05.png";

import icon1 from "../../assets/images/icons/01.png";
import icon2 from "../../assets/images/icons/02.png";
import icon3 from "../../assets/images/icons/03.png";
import icon4 from "../../assets/images/icons/04.png";
import icon8 from "../../assets/images/icons/08.png";
import icon6 from "../../assets/images/icons/06.png";
import icon7 from "../../assets/images/icons/07.png";

import icon5 from "../../assets/images/icons/05.png";
import shap2 from "../../assets/images/shapes/02.png";
import shap4 from "../../assets/images/shapes/04.png";
import shap6 from "../../assets/images/shapes/06.png";
import pages2 from "../../assets/images/pages/02-page.png";
import Progress from "../progress.js";

import BillTable from "./billTable";
import PaymentHistoryTable from "./paymentHistoryTable";
import AccountsTable from "./AccountsTable";

const BillManagement = () => {
  const getVariableColor = () => {
    let prefix =
      getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
    if (prefix) {
      prefix = prefix.trim();
    }
    const color1 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary`
    );
    const color2 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}info`
    );
    const color3 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary-tint-20`
    );
    const color4 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}warning`
    );
    return {
      primary: color1.trim(),
      info: color2.trim(),
      warning: color4.trim(),
      primary_light: color3.trim(),
    };
  };
  const variableColors = getVariableColor();

  const colors = [variableColors.primary, variableColors.info];
  useEffect(() => {
    return () => colors;
  });
   
  console.log("hrrra?");
  const [toggler, setToggler] = useState();
  return (
    <Fragment>
      <FsLightbox
        toggler={toggler}
        sources={[
          icon4,
          shap2,
          icon8,
          shap4,
          icon2,
          shap6,
          icon5,
          shap4,
          icon1,
        ]}
      />
      <Tab.Container defaultActiveKey="first">
        <Row>
          <Col lg="12">
            <Card>
              <Card.Body>
                <div className="d-flex flex-wrap align-items-center justify-content-between">
                  <div className="d-flex flex-wrap align-items-center">
                    <div className="d-flex flex-wrap align-items-center mb-3 mb-sm-0">
                      <h4 className="me-2 h4">Bill Desk</h4>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: "2%" }}>
                  <Nav
                    as="ul"
                    className="d-flex nav-tabs mr-3 mb-0 text-center profile-tab"
                    data-toggle="slider-tab"
                    id="profile-pills-tab"
                    role="tablist"
                  >
                    <Nav.Item as="li" className="me-3">
                      <Nav.Link eventKey="first">Bill</Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li" className="me-3">
                      <Nav.Link eventKey="second">Payment History</Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li" className="me-3">
                      <Nav.Link eventKey="third">Accounts</Nav.Link>
                    </Nav.Item>
                     
                  </Nav>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg="12">
            <Tab.Content className="profile-content">
              <Tab.Pane eventKey="first" id="profile-feed">
               <BillTable/>
                
              </Tab.Pane>
              <Tab.Pane eventKey="second" id="profile-activity">
                <PaymentHistoryTable></PaymentHistoryTable>
                 
              </Tab.Pane>
              <Tab.Pane eventKey="third" id="profile-friends">
                <AccountsTable></AccountsTable>
              </Tab.Pane>
     
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </Fragment>
  );
};

export default BillManagement;
